<template>
    <form @submit.stop.prevent="onSubmit" v-if="company">
        <messages :messages="messages"/>
        <div class="row">
            <div class="col-md-12 container-adduser">
                <template v-if="$userIsSuperAdmin()">
                    <div class="form-row">
                        <b-form-group class="input-group col-md-6"
                                      label="Status"
                                      :label-for="getId('status_id')"
                                      :state="fieldState('status_id')"
                                      :invalid-feedback="invalidField('status_id')"
                        >
                            <b-form-select
                                :id="getId('status_id')"
                                v-model="company.status_id"
                                :disabled="!$userIsSuperAdmin()"
                                class="form-control"
                            >
                                <option :value="1">Active</option>
                                <option v-if="company.status_id === 2" :value="2">Preview</option>
                                <option :value="4">Blocked</option>
                                <option :value="3">Stock only</option>
                            </b-form-select>

                        </b-form-group>
                        <b-form-group class="input-group col-md-6"
                                      label="Stop Credit"
                                      :label-for="getId('stop_credit')"
                                      :state="fieldState('stop_credit')"
                                      :invalid-feedback="invalidField('stop_credit')"
                        >
                            <b-form-checkbox
                                :id="getId('stop_credit')"
                                v-model="company.stop_credit"
                                :state="fieldState('stop_credit')"
                                :value="1"
                                :unchecked-value="0"
                            >
                            </b-form-checkbox>
                        </b-form-group>
                    </div>
                    <div class="form-row">
                        <b-form-group class="input-group col-md-6"
                                      label="Notes"
                                      :label-for="getId('notes')"
                                      :state="fieldState('notes')"
                                      :invalid-feedback="invalidField('notes')"
                        >
                            <b-form-textarea
                                :id="getId('notes')"
                                v-model="company.notes"
                                :state="fieldState('notes')"
                                :rows="6"
                                placeholder="Enter notes">
                            </b-form-textarea>

                        </b-form-group>
                    </div>
                </template>
                <div class="form-row">
                    <b-form-group class="input-group col-md-6"
                                  label="Name"
                                  :label-for="getId('name')"
                                  :state="fieldState('name')"
                                  :invalid-feedback="invalidField('name')"
                    >
                        <b-form-input
                            :id="getId('name')"
                            type="text"
                            v-model="company.name"
                            :state="fieldState('name')"
                            placeholder="Enter name">
                        </b-form-input>

                    </b-form-group>
                    <b-form-group class="input-group col-md-6"
                                  label="Website"
                                  :label-for="getId('website')"
                                  :state="fieldState('website')"
                                  :invalid-feedback="invalidField('website')"
                    >
                        <b-form-input
                            :id="getId('website')"
                            type="text"
                            v-model="company.website"
                            :state="fieldState('website')"
                            placeholder="Enter website">
                        </b-form-input>

                    </b-form-group>
                </div>
                <div class="form-row">
                    <b-form-group class="input-group col-md-6"
                                  label="Phone"
                                  :label-for="getId('phone_number')"
                                  :state="fieldState('phone_number')"
                                  :invalid-feedback="invalidField('phone_number')"
                    >
                        <b-form-input
                            :id="getId('phone_number')"
                            type="text"
                            v-model="company.phone_number"
                            :state="fieldState('phone_number')"
                            placeholder="Enter phone">
                        </b-form-input>

                    </b-form-group>
                </div>
                <div class="form-row">
                    <b-form-group class="input-group col-md-6"
                                  label="Address"
                                  :label-for="getId('address')"
                                  :state="fieldState('address')"
                                  :invalid-feedback="invalidField('address')"
                    >
                        <b-form-textarea
                            :id="getId('address')"
                            v-model="company.address"
                            :state="fieldState('address')"
                            :rows="6"
                            placeholder="Enter address">
                        </b-form-textarea>

                    </b-form-group>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <b-btn type="submit" class="btn">Save</b-btn>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors, makeID} from '../../util/common'
import BootstrapValidation from '../../mixins/bootstrap-validation';
import axios from "axios";
import LaravelRouter from "../../thirdparty/Ziggy/route";

export default {
    props: {
        company: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    status_id: 1,
                    stop_credit: 0,
                    notes: null,
                    name: null,
                    website: null,
                    phone_number: null,
                    address: null,
                }
            }
        },
    },
    async created() {
    },
    mixins: [BootstrapValidation],
    data() {
        return {
            messages: [],
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        async onSubmit() {
            this.messages = [];
            this.errors = [];
            const newCompany = !this.company.id
            let action = 'companies/storeCompany'
            let data = {data: this.company}
            try {
                if (!newCompany) {
                    action = 'companies/updateCompany'
                    data = this.company
                }
                let response = await this.$store.dispatch(action, data);
                if (response) {
                    this.messages.push({type: 'success', message: response.message});
                    this.errors = [];
                } else {

                }
            } catch (error) {
                console.warn('onSubmit error: ', error);
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Companies/EditCompany.vue